//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import application from "@/assets/images/Application.svg";
import global from "@/assets/images/Global.svg";
import task from "@/assets/images/Task.svg";
import DataStore from "@/assets/images/DataStore.svg";
import process from "@/assets/images/Process.svg";
import interfaceBuilder from "@/assets/images/InterfaceBuilder.svg";
import document from "@/assets/images/Document.svg";
import apiState from "@/assets/images/APIState.svg";
import dataModel from "@/assets/images/DataModel.svg";
import catalogs from "@/assets/images/Catalogs.svg";
import perspective from "@/assets/images/Perspective.svg";
import search from "@/assets/images/Search.svg";
import report from "@/assets/images/Report.svg";
import acessDenied from "@/assets/images/AcessDenied.svg";
import blockchain from "@/assets/images/Blockchain.svg";
import wallet from "@/assets/images/Wallet.svg";
import perspectiveProcess from "@/assets/images/PerspectiveProcess.svg";
import scList from "@/assets/images/scList.svg";
import maintenanceImg from "@/assets/images/maintenance.svg";
import pluginImg from "@/assets/images/plugins.svg";
import error404 from "@/assets/images/error404.svg";
import authState from "@/assets/images/AuthState.svg";
import pageNotFound from "@/assets/images/pageNotFound.svg";

export default {
    name: "AQEmptyState",
    components: {
        AQButton
    },
    props: {
        // if you wanna add a new empty state go to emptyStateProps and create a new object
        emptyStateType: { type: String, default: "application" },
        viewOnly: { type: Boolean, default: false },
        mobileView: { type: Boolean, default: false },
        hasContainer: { type: Boolean, default: false } // if you use AQEmptyState and you already have the container set send this as true
    },
    computed: {
        withContainer() {
            let container = "";
            if (!this.hasContainer) {
                if (this.mobileView) {
                    container = "mobile-spacing ";
                }
                container += this.emptyStateProps.type === "platform" ? "au-main-container-platform" : "au-main-container-building";
            }
            return container;
        },
        emptyStateProps() {
            const emptyStateObject = { application: {
                type: "platform",
                title: this.viewOnly ? this.$t("defaultState.createAppView") : this.$t("defaultState.createApp"),
                description: this.viewOnly ? this.$t("defaultState.descriptionAppView") : this.$t("defaultState.descriptionApp"),
                createButton: true,
                secondaryButton: {
                    active: true,
                    label: this.$t("apps.import"),
                    color: "outline"
                },
                src: application
            },
            applicationMobile: {
                title: this.$t("defaultState.createAppView"),
                description: this.$t("defaultState.descriptionAppView"),
                src: application
            },
            entity: {
                type: "platform",
                title: this.$t("defaultState.createEntity"),
                description: this.$t("defaultState.descriptionEntity"),
                createButton: true,
                secondaryButton: {
                    active: false
                },
                src: global
            },
            entityDataStoreNew: {
                type: "platform",
                title: this.$t("defaultState.createEntity"),
                description: this.$t("defaultState.descriptionEntity"),
                createButton: true,
                secondaryButton: {
                    active: true,
                    label: this.$t("apps.import"),
                    color: "outline",
                    icon: "add"
                },
                src: DataStore
            },
            integration: {
                type: "platform",
                title: this.$t("defaultState.createIntegration"),
                description: this.$t("defaultState.descriptionIntegration"),
                createButton: true,
                secondaryButton: {
                    active: false
                },
                src: global
            },
            notasks: {
                type: "platform",
                title: this.$t("defaultState.noTasks"),
                description: this.$t("defaultState.noTasksDescription"),
                createButton: false,
                secondaryButton: {
                    active: false
                },
                src: task
            },
            noteamtask: {
                type: "platform",
                title: this.$t("defaultState.noTeamTasks"),
                description: this.$t("defaultState.noTeamTasksDescription"),
                createButton: false,
                secondaryButton: {
                    active: false
                },
                src: task
            },
            createProcess: {
                type: "building",
                title: this.viewOnly ? this.$t("defaultState.createProcessView") : this.$t("defaultState.createProcess"),
                description: this.viewOnly ? this.$t("defaultState.createProcessDescriptionView") : this.$t("defaultState.createProcessDescription"),
                createButton: true,
                secondaryButton: {
                    active: false
                },
                src: process
            },
            createSC: {
                type: "building",
                title: this.viewOnly ? this.$t("defaultState.createSCView") : this.$t("defaultState.createSC"),
                description: this.viewOnly ? this.$t("defaultState.createSCDescriptionView") : this.$t("defaultState.createSCDescription"),
                createButton: true,
                secondaryButton: {
                    active: true,
                    label: this.$t("apps.import"),
                    color: "outline"
                },
                src: blockchain
            },
            createInterface: {
                type: "building",
                title: this.$t("defaultState.createInterface"),
                description: this.viewOnly ? this.$t("defaultState.createInterfaceDescriptionView") : this.$t("defaultState.createInterfaceDescription"),
                createButton: true,
                secondaryButton: {
                    active: false
                },
                src: interfaceBuilder
            },
            createDocument: {
                type: "building",
                title: this.viewOnly ? this.$t("defaultState.createDocumentView") : this.$t("defaultState.createDocument"),
                description: this.viewOnly ? this.$t("defaultState.createDocumentDescriptionView") : this.$t("defaultState.createDocumentDescription"),
                createButton: true,
                secondaryButton: {
                    active: false
                },
                src: document
            },
            internalApis: {
                type: "building",
                title: this.$t("defaultState.internalApis"),
                description: this.$t("defaultState.internalApisDescription"),
                createButton: false,
                secondaryButton: {
                    active: false
                },
                src: apiState
            },
            consumedApis: {
                type: "building",
                title: this.viewOnly ? this.$t("defaultState.consumedApisView") : this.$t("defaultState.consumedApis"),
                description: this.viewOnly ? this.$t("defaultState.consumedApisDescriptionView") : this.$t("defaultState.consumedApisDescription"),
                createButton: true,
                secondaryButton: {
                    active: false
                },
                src: apiState
            },
            exposedApis: {
                type: "building",
                title: this.viewOnly ? this.$t("defaultState.exposedApisView") : this.$t("defaultState.exposedApis"),
                description: this.viewOnly ? this.$t("defaultState.exposedApisDescriptionView") : this.$t("defaultState.exposedApisDescription"),
                createButton: true,
                secondaryButton: {
                    active: false
                },
                src: apiState
            },
            createDM: {
                type: "building",
                title: this.viewOnly ? this.$t("defaultState.createDMView") : this.$t("defaultState.createDM"),
                description: this.viewOnly ? this.$t("defaultState.createDMDescriptionView") : this.$t("defaultState.createDMDescription"),
                createButton: true,
                secondaryButton: {
                    active: false
                },
                src: dataModel
            },
            createCatalog: {
                type: "building",
                title: this.viewOnly ? this.$t("defaultState.createCatalogView") : this.$t("defaultState.createCatalog"),
                description: this.viewOnly ? this.$t("defaultState.createCatalogDescriptionView") : this.$t("defaultState.createCatalogDescription"),
                createButton: true,
                secondaryButton: {
                    active: false
                },
                src: catalogs
            },
            createPerspective: {
                type: "building",
                title: this.viewOnly ? this.$t("defaultState.createPerspectiveView") : this.$t("defaultState.createPerspective"),
                description: this.viewOnly ? this.$t("defaultState.createPerspectiveDescriptionView")
                    : this.$t("defaultState.createPerspectiveDescription"),
                createButton: true,
                secondaryButton: {
                    active: false
                },
                src: perspective
            },
            noPerspective: {
                type: "building",
                title: this.$t("defaultState.noPerspective"),
                description: this.$t("defaultState.noPerspectiveDescription"),
                createButton: false,
                secondaryButton: {
                    active: false
                },
                src: search
            },
            noPerspectiveProcess: {
                type: "building",
                title: this.$tc("searchPerspectives.noProcessTitle", 1),
                description: this.$tc("searchPerspectives.noProcessTitle", 2),
                createButton: false,
                secondaryButton: {
                    active: true,
                    label: this.$t("searchPerspectives.goToSearchRedirect"),
                    color: "primary"
                },
                firstButton: {
                    active: true,
                    label: this.$t("searchPerspectives.tryAgain"),
                    color: "outline"
                },
                src: perspectiveProcess
            },
            noStatistics: {
                type: "building",
                title: this.viewOnly ? this.$t("defaultState.noStatisticsView") : this.$t("defaultState.noStatistics"),
                description: this.viewOnly ? this.$t("defaultState.noStatisticsDescriptionView") : this.$t("defaultState.noStatisticsDescription"),
                createButton: false,
                secondaryButton: {
                    active: false
                },
                src: report
            },
            noProcessData: {
                type: "building",
                title: this.viewOnly ? this.$t("defaultState.noProcessDataView") : this.$t("defaultState.noProcessData"),
                description: this.viewOnly ? this.$t("defaultState.noProcessDataDescriptionView") : this.$t("defaultState.noProcessDataDescription"),
                createButton: false,
                secondaryButton: {
                    active: false
                },
                src: report
            },
            acessDenied: {
                type: "platform",
                title: this.$t("defaultState.acessDenied"),
                description: this.$t("defaultState.acessDeniedDescription"),
                createButton: false,
                secondaryButton: {
                    active: true,
                    label: this.$t("defaultState.toDashboard"),
                    color: "primary"
                },
                src: acessDenied
            },
            blockchainWallet: {
                type: "platform",
                title: this.viewOnly ? this.$t("defaultState.blockchainEmptyWalletView") : this.$t("defaultState.blockchainEmptyWallet"),
                description: this.$t("defaultState.blockchainEmptyWalletDescription"),
                createButton: true,
                secondaryButton: {
                    active: true,
                    label: this.$t("apps.import"),
                    color: "outline"
                },
                src: wallet
            },
            scList: {
                type: "building",
                title: this.viewOnly ? this.$t("defaultState.createSCView") : this.$t("defaultState.createSC"),
                description: this.viewOnly ? this.$t("defaultState.createSCDescriptionView") : this.$t("defaultState.createSCDescription"),
                createButton: false,
                secondaryButton: {
                    active: true,
                    label: this.$t("apps.import"),
                    color: "outline"
                },
                src: scList

            },
            maintenance: {
                type: "platform",
                title: this.$t("defaultState.maintenanceTitle"),
                description: this.$t("defaultState.maintenanceDescription"),
                createButton: false,
                secondaryButton: {
                    active: true,
                    label: this.$t("mainPage.maintenanceRefresh"),
                    color: "outline"
                },
                src: maintenanceImg
            },
            plugins: {
                type: "building",
                title: this.$t("defaultState.createPlugin"),
                description: this.$t("defaultState.descriptionPlugin"),
                createButton: false,
                secondaryButton: {
                    active: true,
                    label: this.$t("defaultState.import"),
                    color: "primary"
                },
                src: pluginImg
            },
            invalidTenant: {
                type: "platform",
                title: this.$t("login.invalidTenantTitle"),
                description: this.$t("login.invalidTenantDescription"),
                createButton: false,
                secondaryButton: {
                    active: false
                },
                src: error404
            },
            taskNotAvailable: {
                type: "platform",
                title: this.$t("tasks.taskNotAvailable"),
                createButton: false,
                secondaryButton: {
                    active: true,
                    label: this.$t("defaultState.toDashboard"),
                    color: "primary"
                },
                src: error404
            },
            authentication: {
                type: "building",
                title: this.$t("defaultState.authenticationTitle"),
                description: this.$t("defaultState.authenticationDescription"),
                createButton: true,
                secondaryButton: {
                    active: false
                },
                src: authState
            },
            pageNotFound: {
                type: "platform",
                title: this.$t("defaultState.pageNotFoundTitle"),
                description: this.$t("defaultState.pageNotFoundDescription"),
                createButton: false,
                secondaryButton: {
                    active: true,
                    label: this.$t("defaultState.toDashboard"),
                    color: "primary"
                },
                src: pageNotFound
            } };
            return emptyStateObject[this.emptyStateType];
        }
    },
    methods: {
        createNew() {
            this.$emit("create");
        },
        firstButton() {
            this.$emit("firstBtn");
        },
        secondaryButton() {
            this.$emit("secondary");
        }
    }
};
